import React from "react";
import {
  View,
  Text,
  StyleSheet,
  Platform,
  useWindowDimensions,
} from "react-native";
import GlobalStyles from "./StylenColor";
import { widthPercentageToDP as wp , heightPercentageToDP as hp} from "react-native-responsive-screen";

const getSolidColor = (percentage) => {
  if (percentage === null || percentage === undefined) return "#d6e7d9";
  if (percentage <= 12.5) return "#fc1102";
  if (percentage <= 25) return "#fc4b02";
  if (percentage <= 37.5) return "#feb003";
  if (percentage <= 50) return "#f3e802";
  if (percentage <= 62.5) return "#d5fd00";
  if (percentage <= 75) return "#a5e600";
  if (percentage <= 87.5) return "#66cc66";
  return "#2e8b57";
};

const QuarterBadge = ({ quarter, percentage, selected }) => {
  const displayText =
    percentage === null || percentage === undefined
      ? "NE"
      : `${Math.round(percentage)}%`;

  const backgroundColor = getSolidColor(percentage);
  const { width } = useWindowDimensions();
  const isWeb = Platform.OS === "web" && width > 768;

  const badgeSize = isWeb
    ? {
        width: wp("7.5%"),
        height: hp("8%"),
      }
    : {
        width: wp("22%"),
        height: wp("12%"),
      };

  return (
    <View style={styles.badgeContainer}>
      <Text style={[styles.quarterText, isWeb && { fontSize: GlobalStyles.fontSize.sm}]}>{quarter}</Text>
      <View
        style={[
          styles.badge,
          badgeSize,
          { backgroundColor },
          selected ? styles.selectedBadge : styles.unselectedBadge,
          isWeb && { marginBottom: 0},
        ]}
      >
        <Text style={[styles.badgeText, isWeb && {fontSize: GlobalStyles.fontSize.topTitle}]}>{displayText}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  badgeContainer: {
    flex: 1,
    alignItems: "center",
    width: "100%",
    justifyContent: "space-evenly",
    alignContent: "space-evenly"
  },
  quarterText: {
    fontFamily: GlobalStyles.GlobalFont.fontFamily,
    marginBottom: 5,
    fontSize: GlobalStyles.fontSize.lg,
    color: GlobalStyles.GlobalBg.headerColor,
  },
  badge: {
    borderRadius: 8,
    justifyContent: "center",
    alignItems: "center",
    elevation: 2,
    marginBottom: 40,
    borderColor: "#9bbba1",
    borderWidth: 1,
    maxHeight: 40,
  },
  selectedBadge: {
    borderColor: "#1e6b3d",
    borderWidth: 2,
    opacity: 1,
  },
  unselectedBadge: {
    borderColor: "#d0d0d0",
    opacity: 0.4,
  },
  badgeText: {
    color: "black",
    fontFamily: GlobalStyles.GlobalFont.fontFamily,
    fontSize: GlobalStyles.fontSize.sm,
  },
});

export default QuarterBadge;
